import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'

import { BeketError } from './components/beket-error'
import { BeketPending } from './components/beket-pending'
import { BeketSuccess } from './components/beket-success'

type Props = {
  status: RESULT_PAYMENT
}

export const BeketPayment = ({ status }: Props) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.myOrders.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <BeketError onClick={onClick} />
  }

  if (
    status === RESULT_PAYMENT.IN_PROGRESS ||
    status === RESULT_PAYMENT.CREATED ||
    status === RESULT_PAYMENT.LOADING
  ) {
    return <BeketPending onClick={onClick} />
  }
  return <BeketSuccess onClick={onClick} />
}
